// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__TY12c","label":"textarea_label__8RU5l"};